/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_common_clear_search = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear search`)
};

const es_common_clear_search = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrar búsqueda`)
};

const de_common_clear_search = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suche leeren`)
};

const nl_common_clear_search = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoekopdracht wissen`)
};

const fr_common_clear_search = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effacer la recherche`)
};

const it_common_clear_search = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancella ricerca`)
};

const pt_br2_common_clear_search = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpar busca`)
};

const pt_common_clear_search = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpar pesquisa`)
};

const ja_common_clear_search = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`検索をクリア`)
};

const zh_common_clear_search = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`清除搜索`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const common_clear_search = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.common_clear_search(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("common_clear_search", locale)
	if (locale === "en") return en_common_clear_search(inputs)
	if (locale === "es") return es_common_clear_search(inputs)
	if (locale === "de") return de_common_clear_search(inputs)
	if (locale === "nl") return nl_common_clear_search(inputs)
	if (locale === "fr") return fr_common_clear_search(inputs)
	if (locale === "it") return it_common_clear_search(inputs)
	if (locale === "pt-BR") return pt_br2_common_clear_search(inputs)
	if (locale === "pt") return pt_common_clear_search(inputs)
	if (locale === "ja") return ja_common_clear_search(inputs)
	return zh_common_clear_search(inputs)
};